module.exports = __webpack_public_path__ + "media/images/poster-blog-5aad177b53dcde6729ca82b6db6a2ad9.jpeg";